import { render } from "./MagentoFindOutMore.vue?vue&type=template&id=1aeb4e19"
import script from "./MagentoFindOutMore.vue?vue&type=script&lang=js"
export * from "./MagentoFindOutMore.vue?vue&type=script&lang=js"

import "./MagentoFindOutMore.vue?vue&type=style&index=0&id=1aeb4e19&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__